// extracted by mini-css-extract-plugin
export var section = "industry-module--section--2fxOE";
export var inner = "industry-module--inner--3QtS_";
export var jsAnimInit = "industry-module--jsAnimInit--2s2WS";
export var hero = "industry-module--hero--38Q1g";
export var list = "industry-module--list--CuOMR";
export var imgWrap = "industry-module--imgWrap--2Y-2T";
export var content = "industry-module--content--2ptTX";
export var title = "industry-module--title--1Q73A";
export var title_markered = "industry-module--title_markered--2D9-P";